// Bridges the SoundNotifications context into the module-scoped trade
// stream so live cockpit trades play the same tiered/million alerts that
// /trades has always played. Mount once at the cockpit page root.
//
// Why a hook rather than wiring sound directly into tradeStream.js:
// tradeStream is a singleton module — it can't useContext. This hook is
// the React-side handshake. On unmount it clears the handlers so a
// non-cockpit page (e.g. WidgetEmbed) never accidentally plays sounds.

import { useEffect } from 'react';
import { setSoundHandlers } from './tradeStream';
import { useOptionalSoundNotificationsContext } from '../../../contexts/SoundNotificationsContext';

export function useTradeStreamSounds() {
  const ctx = useOptionalSoundNotificationsContext();

  useEffect(() => {
    if (!ctx) return undefined;
    setSoundHandlers({
      getTier: ctx.getTier,
      playTieredSound: ctx.playTieredSound,
      playMillionAlert: ctx.playMillionAlert,
    });
    return () => setSoundHandlers(null);
  }, [ctx]);
}
